export default {
  namespaced: true,
  modules: {
    search: {
      namespaced: true,
    },
    editor: {
      namespaced: true,
    },
  },
};
